import { render, staticRenderFns } from "./common-ad-add.vue?vue&type=template&id=37d20fb8&scoped=true&"
import script from "./common-ad-add.vue?vue&type=script&lang=js&"
export * from "./common-ad-add.vue?vue&type=script&lang=js&"
import style0 from "./common-ad-add.vue?vue&type=style&index=0&id=37d20fb8&scoped=true&lang=scss&"
import style1 from "./common-ad-add.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d20fb8",
  null
  
)

export default component.exports